import React, { Fragment } from "react";
import { intlShape, injectIntl, FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import messages from "components/messagesDescription";
import FooterLogoPP from "./FooterLogoPP";
import moment from "moment";
import { setLanguageByCode } from "../../actions/localizationActions";
import LanguageSelectorPP from "./LanguageSelectorPP";
import { clearProviderProducts } from "../../actions/marketplaceActions";

const FooterPP = ({ intl, client = "", hideLanguageSelector = false }) => {
  const dispatch = useDispatch();
  const selectedLanguage = useSelector(state => state.localization.selectedLanguage);
  const year = moment().format("Y");
  const copyrightCopy = intl.formatMessage(messages.businessNameDescription);
  const isCXAClient = client !== "libertyxchange";

  const handleCountryChange = value => {
    dispatch(setLanguageByCode(value));
    dispatch(clearProviderProducts());
  };

  return (
    <div className="footer-container">
      <div className="left-section">
        {isCXAClient && (
          <p className="footer-text">
            {" "}
            <span aria-label="Copyright">
              {"\u00A9"}
            </span>
            {` ${year} `}
            {copyrightCopy}
          </p>
        )}
      </div>
      <div className="right-section">
        <div className="footer-text">
          {!hideLanguageSelector && (
            <Fragment>
              <LanguageSelectorPP
                selectedLanguage={selectedLanguage}
                handleCountryChange={handleCountryChange}
              />
              <span className="cxa-language"></span>
            </Fragment>
          )}
          <Link className="footer__nav-item" to="/contact">
            <FormattedMessage {...messages.contactUsDescription} />
          </Link>
          <a
            className="footer__nav-item"
            href={intl.formatMessage(messages.termsLink)}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FormattedMessage {...messages.termsDescription} />
          </a>
          <a
            className="footer__nav-item"
            href={intl.formatMessage(messages.privacyLink)}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FormattedMessage {...messages.privacyDescription} />
          </a>
        </div>
        <FooterLogoPP aria-hidden={true} className="footer__logo" />{" "}
      </div>
    </div>
  );
};

FooterPP.propTypes = {
  intl: intlShape.isRequired,
  client: PropTypes.string,
  hideLanguageSelector: PropTypes.bool,
};
export default injectIntl(FooterPP);



// WEBPACK FOOTER //
// ./components/common/FooterPP.jsx